(() => {
  let lastUrlParams =
    new URLSearchParams(window.location.search).get("page") ?? "1";

  const addSwatchButtonListeners = () => {
    console.log("getting here at least dude");
    const swatchButtons = document.querySelectorAll(".collection__item-swatch");

    swatchButtons.forEach((button) => {
      const container = button.closest(".collection__item");

      if (container) {
        button.addEventListener("click", (e) => {
          const variantId = button.getAttribute("data-variant-id");

          if (variantId) {
            container.setAttribute("data-variant-id", variantId);
          }

          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("abra:render"));
          }, 500);
        });
      }
    });

    const productButtonSwatches = document.querySelectorAll(".product__swatch");

    productButtonSwatches.forEach((button) => {
      const activeLensActiveStepContainer = document.querySelector(
        ".product__lens-selection-step.active"
      );

      if (activeLensActiveStepContainer) {
        button.addEventListener("click", (e) => {
          console.log("clicked on the button");
          const variantId = button.getAttribute("data-variant-id");

          if (variantId) {
            if (activeLensActiveStepContainer) {
              activeLensActiveStepContainer.setAttribute(
                "data-variant-id",
                variantId
              );
            }
          }

          setTimeout(() => {
            window.dispatchEvent(new CustomEvent("abra:render"));
          }, 500);
        });

        if (button.classList.contains("active")) {
          activeLensActiveStepContainer.setAttribute(
            "data-variant-id",
            variantId
          );
        }
      }
    });
  };

  const initialize = () => {
    const currentUrlParams =
      new URLSearchParams(window.location.search).get("page") ?? "1";

    if (currentUrlParams !== lastUrlParams) {
      lastUrlParams = currentUrlParams;

      setTimeout(addSwatchButtonListeners, 2000);
    }
  };

  window.addEventListener("DOMContentLoaded", () => {
    setTimeout(addSwatchButtonListeners, 2000);
  });

  window.addEventListener("popstate", initialize);
  window.addEventListener("pushState", initialize);
  window.addEventListener("replaceState", initialize);

  const originalPushState = history.pushState;
  history.pushState = function (...args) {
    originalPushState.apply(this, args);
    window.dispatchEvent(new Event("pushState"));
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function (...args) {
    originalReplaceState.apply(this, args);
    window.dispatchEvent(new Event("replaceState"));
  };
})();
